import React from 'react';
import { CalSlug, calConfig, calLink, calUrl, isCalReady } from '../../utils/cal';
type CalButtonProps = {
  slug?: CalSlug;
  variant?: 'primary' | 'text';
  /** light = cream sections (default), dark = dark blue hero */
  tone?: 'light' | 'dark';
  className?: string;
  children: React.ReactNode;
  onAfterClick?: () => void;
};
const PRIMARY_BASE = 'inline-flex items-center justify-center px-8 py-3 rounded-full font-medium text-lg tracking-wide transition-colors duration-200 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2';
const TEXT_BASE = 'underline underline-offset-2 transition-colors font-sans text-base focus:outline-none focus-visible:ring-2 rounded';
const STYLES = {
  light: {
    primary: `${PRIMARY_BASE} bg-bronze-500 text-white hover:bg-bronze-600 focus-visible:ring-bronze-400 focus-visible:ring-offset-paper`,
    text: `${TEXT_BASE} text-bronze-600 hover:text-ink-900 focus-visible:ring-bronze-400`
  },
  dark: {
    primary: `${PRIMARY_BASE} bg-gold-400 text-ink-900 hover:bg-gold-500 focus-visible:ring-gold-400 focus-visible:ring-offset-navy`,
    text: `${TEXT_BASE} text-gold-400 hover:text-gold-300 focus-visible:ring-gold-400/60`
  }
};

/**
 * Plain <button> wired to the official Cal.com embed via data attributes.
 * If the embed script hasn't loaded (blocked, offline, timed out), it falls
 * back to opening the booking page in a new tab.
 */
export function CalButton({
  slug = '30min',
  variant = 'primary',
  tone = 'light',
  className = '',
  children,
  onAfterClick
}: CalButtonProps) {
  const handleClick = () => {
    if (!isCalReady()) {
      window.open(calUrl(slug), '_blank', 'noopener');
    }
    onAfterClick?.();
  };
  return <button type="button" data-cal-link={calLink(slug)} data-cal-config={calConfig} onClick={handleClick} className={`${STYLES[tone][variant]} ${className}`} data-id="element-211" data-mp="1vn31j0oqk2y8">
      {children}
    </button>;
}